/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import metadata from './BuildingAdditionalInterestDetails.metadata.json5';
import messages from './BuildingAdditionalInterestDetails.messages.js';
import styles from '../BuildingAdditionalInterest.module.scss';
import { TWIAStandardizeButton, TWIAStandardizationStatus } from 'twia-capability-address-component';
import StandardAddressValidationUtil from '../../../../../modules-react/twia-capability-address-component/util/StandardAddressValidationUtil';
import addressControl from '../../../../../modules-react/twia-capability-address-component/util/addressControl.js';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
import { LocaleService_TWIA } from 'twia-capability-locale';

function BuildingAdditionalInterestDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { item, saveData, cancelData, isInvalid, showErrors, onValidate, 
        companyType, submissionVM, locationId, buildingId, disregardFieldValidation } = props;
    const {
        isComponentValid,
        onValidate: setComponentValidation,
    } = useValidation('BuildingAdditionalInterestDetails');

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);
    const [additionalInfoVM, setAdditionalInfoVM] = useState(item);
    const [zipcodeValidationMessage, setZIPCodeValidationMessage] = useState([]);
    const [emailValidationMessage, setEmailValidationMessage] = useState([]);
    const [cityLabel, setCityLabel] = useState([]);
    const [zipCodeLabel, setZIPCodeLabel] = useState([]);
    const [stateLabel, setStateLabel] = useState([]);
    const { refreshData } = useDataRefresh();
    const countryCode = _.get(additionalInfoVM, 'primaryAddress.country.value.code');
    const [placeholderMsg, setPlaceHolderMsg] = useState('');
    const postalCode = _.get(additionalInfoVM, 'primaryAddress.postalCode.value');
    const personContact = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.ContactType').getCode('person');
    const companyContact = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.ContactType').getCode('company');
    const [displayError, setDisplayError] = useState(false);
    const isContractNumberVisible = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].contractNumber.aspects.visible');
    const isContractNumberRequired = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].contractNumber.aspects.required');
    const [cedexBureauValidationMessage, setCedexBureauValidationMessage] = useState([]);
    const [showAddressValidationStatus, setStatus] = useState(false);
    const interestTypeValue = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].type.value.code');
    const { authHeader } = useAuthentication();
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [regex, setRegex] = useState('');
    const [addInterestButton, setaddInterestButton] = useState(false);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false); //DE16671
    const [noMatchFound, setNoMatchFound] = useState(false);
    const xPortal = 'PE';
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';
    const mailingAddressTypeCode = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.AddressType').getCode('mailingExt');
    const usCountryCode = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.Country').getCode('US');
    const errorHandling = useCallback(() => {
        if (!displayError) { setDisplayError(true) }
    }, [displayError]);

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'BuildingAdditionalInterestDetails');
        }
    }, [isComponentValid, onValidate]);

    // useEffect(() => {
    //     const val = primaryAddressVM?.value || primaryAddressVM; 
    //     setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
    // },[primaryAddressVM]);

    useEffect(() => {
        isInvalid(isComponentValid, 'BuildingAdditionalInterestDetails');
    }, [isInvalid, isComponentValid])

    useEffect(() => {
        getLabel(countryCode);
        getAddressConfig(countryCode);
        getPCConstants();
        setStatus(addressControl.showStatus(additionalInfoVM.primaryAddress.value, xPortal));
        if(interestTypeValue === 'MORTGAGEE' || interestTypeValue === 'PREMFINANCE_TWIA' || countryCode !== 'US'){
            _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
            setAdditionalInfoVM(additionalInfoVM);
        } else {
            _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', true);
            setAdditionalInfoVM(additionalInfoVM);
        }
    }, [countryCode]);

    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, []);

    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal));
            setaddInterestButton(true);
        }
        refreshData();
    }, [updateDisablity, refreshData]);

    const getLabel = (value) => {
        setZIPCodeLabel([]);
        setCityLabel([]);
        setStateLabel([]);

        switch (value) {
            case 'US':
                setZIPCodeLabel('ZIP Code');
                setCityLabel('City');
                setStateLabel('State');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            case 'CA':
                setZIPCodeLabel('Postal Code');
                setCityLabel('City');
                setStateLabel('Province');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            case 'GB':
                setCityLabel('Town/City');
                setZIPCodeLabel('Postcode');
                setStateLabel('State');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            case 'JP':
                setCityLabel('City (phonetic)');
                setZIPCodeLabel('Postcode');
                setStateLabel('Prefecture');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            default:
                setCityLabel('City');
                setZIPCodeLabel('Postcode');
                setStateLabel('State');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
        }
    }

    // DE16332 contract of Sale should not be available for 'Business Property Only' coverage form
    const getAdditionalInterestTypeValues = useCallback(() => {
        const coverageFormType = _.get(submissionVM, 'lobData.commercialProperty.coverables.locations.value')
            .map((location) => _.get(location, 'buildings[0].coverageForm'))
            .filter(Boolean);
        const availableInterestTypeValues = additionalInfoVM.policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].type.aspects.availableValues;
        if (availableInterestTypeValues.length > 0) {
            const availableInterestType = availableInterestTypeValues
                .filter((code) => {
                    return !(coverageFormType[0] === 'TWCP' && code.code === 'CONSALE');
                })
                .map((code) => {
                    return { code: code.code, name: translator({ id: code.name }) };
                });
            return availableInterestType;
        }
    }, [additionalInfoVM, translator, submissionVM]);

    const getAvailablePremiumFinaceCompany = useMemo(() => {
        const availablePremiumFinanceValues = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.PremiumFinCompany_TWIA').codes.map((code) => {
            return {
                code: code.code,
                name: translator({ id: code.name })
            }
        })

        return availablePremiumFinanceValues
    }, [viewModelService, translator]);

    const contactTypeChange = useCallback((value, path) => {
        const newAdditionalInfoVM = viewModelService.create({}, 'pc', 'edge.capabilities.gateway.contact.dto.PolicyContactDetailsDTO');
        newAdditionalInfoVM.active = true;
        
        newAdditionalInfoVM.primaryAddress.value = {};
        newAdditionalInfoVM.primaryAddress.addressType.value = mailingAddressTypeCode
        newAdditionalInfoVM.primaryAddress.country.value = usCountryCode;

        const pcr = { subtype: 'PolicyAddlInterest' };

        pcr.accountContactRole = { subtype: 'AdditionalInterest' };
        let additionalInterestDetail = {};
        _.set(newAdditionalInfoVM, path, value);
        if (value === 'Person') {
            _.set(newAdditionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].contactType.value', personContact.code)
            newAdditionalInfoVM.contactType_TWIA.value = personContact.code;
            additionalInterestDetail = { subtype: 'CPBldgAddlInterest', locationId, buildingId, contactType: personContact.code, filterType: 'CPBldgAddlInterest' };
        } else {
            _.set(newAdditionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].contactType.value', companyContact.code)
            newAdditionalInfoVM.contactType_TWIA.value = companyContact.code;
            additionalInterestDetail = { subtype: 'CPBldgAddlInterest', locationId, buildingId, contactType: companyContact.code, filterType: 'CPBldgAddlInterest' };
        }               

        pcr.policyAdditionalInterest = { cpAdditionalInterestDetails_TWIA: [additionalInterestDetail] };
        newAdditionalInfoVM.cpAdditionalInterestDetails = additionalInterestDetail;
        newAdditionalInfoVM.policyContactRoles.value = [pcr];
        setAdditionalInfoVM(newAdditionalInfoVM);
        getAdditionalInterestTypeValues();
        refreshData();
    }, [companyContact, getAdditionalInterestTypeValues, personContact, refreshData]);

    const interestTypeChange = useCallback((value, path) => {
        const newAdditionalInfoVM = viewModelService.create({}, 'pc', 'edge.capabilities.gateway.contact.dto.PolicyContactDetailsDTO');
        newAdditionalInfoVM.active = true;
        const selectedAdditionalInterestType = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.AdditionalInterestType').getCode(value);
        newAdditionalInfoVM.primaryAddress.value = {};
        newAdditionalInfoVM.primaryAddress.addressType.value = mailingAddressTypeCode
        newAdditionalInfoVM.primaryAddress.country.value = usCountryCode;

        const pcr = { subtype: 'PolicyAddlInterest' };

        pcr.accountContactRole = { subtype: 'AdditionalInterest' };
        let additionalInterestDetail = {};

        _.set(newAdditionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].contactType.value', additionalInfoVM.subtype.value)
        newAdditionalInfoVM.contactType_TWIA.value = additionalInfoVM.subtype.value;
        newAdditionalInfoVM.subtype.value = additionalInfoVM.subtype.value;
        const contactType = additionalInfoVM.subtype.value === "Company" ? companyContact.code : personContact.code;
        additionalInterestDetail = { subtype: 'CPBldgAddlInterest', locationId, buildingId, contactType: contactType, filterType: 'CPBldgAddlInterest' };    

        pcr.policyAdditionalInterest = { cpAdditionalInterestDetails_TWIA: [additionalInterestDetail] };
        newAdditionalInfoVM.cpAdditionalInterestDetails = additionalInterestDetail;
        newAdditionalInfoVM.policyContactRoles.value = [pcr];
        _.set(newAdditionalInfoVM, path, value);
        setAdditionalInfoVM(newAdditionalInfoVM);
        // getAdditionalInterestTypeValues();
        refreshData();
    }, [companyContact, personContact, refreshData]);

    const countryChange = useCallback((value, path) => {
        _.set(additionalInfoVM, 'primaryAddress.state', undefined)
        if(value !== 'US'){
            _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
            setAdditionalInfoVM(additionalInfoVM);
            setaddInterestButton(true);
        } else {
            _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', true);
            setAdditionalInfoVM(additionalInfoVM);
        }
        if (postalCode !== undefined) {
            _.set(additionalInfoVM, 'primaryAddress.postalCode', undefined)
        }
        getLabel(value);
        getAddressConfig(value);
        setStatus(addressControl.showStatus(additionalInfoVM.primaryAddress.value, xPortal));
        _.set(additionalInfoVM, path, value);
        setAdditionalInfoVM(additionalInfoVM);
        refreshData();
    }, [additionalInfoVM, refreshData, postalCode]);

    const getAddressConfig = useCallback(
        async (value) => {
            await LocaleService_TWIA.getLocal_TWIA(value, authHeader).then(
                (locale) => {
                    setRegex(locale.postalCodeRegex);
                }
            )
        },
        []);

    const validateRegex = (idRegex, target) => {
        // eslint-disable-next-line security/detect-non-literal-regexp
        if(idRegex === undefined){
            return true
        }
        const regex = new RegExp(`^${idRegex}$`); //DE16011
    
        return regex.test(target);
    };
    
    const validateZIPCode = useCallback(() => {
        const code = _.get(additionalInfoVM.primaryAddress.value, 'postalCode');
        const isCodevalid = code === "" ? true : validateRegex(regex, code); //DE16011
        setZIPCodeValidationMessage([]);
        if (!isCodevalid ){   
            setZIPCodeValidationMessage([translator(messages.ZIPCodeValidationMessage)]); //DE16364
        }
        return '';
    }, [additionalInfoVM, regex]);

    const validateEmail = useCallback(
        (value, path) => {
            _.set(additionalInfoVM, path, value);
            setEmailValidationMessage([]);

            if (!value) {

                setEmailValidationMessage([]);
            } else if (!_.get(additionalInfoVM, `${path}.aspects.valid`)) {

                setEmailValidationMessage([translator(messages.EmailValidationMessage)])
            }

            setAdditionalInfoVM(additionalInfoVM);
        },
        [additionalInfoVM, translator]);

    const cedexBureauChange = useCallback(
        (value, path) => {
            _.set(additionalInfoVM, path, value);
            setCedexBureauValidationMessage([]);

            if (value.length > 2) {

                setCedexBureauValidationMessage([translator(messages.cedexBureauMessage)])
            }

            setAdditionalInfoVM(additionalInfoVM);
        },
        [additionalInfoVM, translator]);

    
    const saveAdditionalInterest = () => {
        if(!isComponentValid) {
            errorHandling();
            isInvalid(isComponentValid, 'AdditionalInsuredDetails');
        } else {
            saveData(additionalInfoVM);
            setIsAddressEdited(false);
        }
    }

    const writeValue = useCallback(
        (value, path) => {
            if (path === 'primaryAddress.addressLine1'
                || path === 'primaryAddress.addressLine2'
                || path === 'primaryAddress.city'
                || path === 'primaryAddress.state'
                || path === 'primaryAddress.county'
                || path === 'primaryAddress.postalCode'
                || path === 'primaryAddress.country') {
                StandardAddressValidationUtil.setNotValidated(additionalInfoVM.primaryAddress.value);
                setStatus(addressControl.showStatus(additionalInfoVM.primaryAddress.value, xPortal));
                setAdditionalInfoVM(additionalInfoVM);
                // DE16765
                if (countryCode === 'US') {
                    if (interestTypeValue === 'MORTGAGEE') {
                        _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
                        setIsAddressEdited(false);
                    } else {
                        setIsAddressEdited(true);
                    }
                } else {
                    setIsAddressEdited(false);
                }
            }
            if (path === 'primaryAddress.country') {
                getLabel(value)
            }
            // DE16579
            if (path === 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].type') {
                if (value === 'MORTGAGEE') {
                    _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
                    setAdditionalInfoVM(additionalInfoVM);
                } else {
                    _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', true);
                    setAdditionalInfoVM(additionalInfoVM);
                }
            }
            _.set(additionalInfoVM, path, value);
            setAdditionalInfoVM(additionalInfoVM);
            refreshData();
        },
        [additionalInfoVM, refreshData]
    );

    const handleStandardizationResponse =useCallback((value)=> {
        const val = additionalInfoVM.primaryAddress?.value || additionalInfoVM.primaryAddress; //DE17215
        if(xPortal === 'CC'){
            setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
        } else {
            setNoMatchFound(value.noAddressMatchFound);
        }
    });
    
    const updateSubmissionVM = useCallback((value) => {
        _.set(additionalInfoVM, 'primaryAddress', value);
        setDisablity(value);
        setIsAddressEdited(false); //DE16671
        setAdditionalInfoVM(additionalInfoVM);
    }, [additionalInfoVM, setAdditionalInfoVM]);        

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        name: {
            visible: additionalInfoVM?.subtype.value === 'Company'
        },
        firstName: {
            visible: additionalInfoVM?.subtype.value === 'Person'
        },
        lastName: {
            visible: additionalInfoVM?.subtype.value === 'Person'
        },
        interestType: {
            path: 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].type',
            availableValues: additionalInfoVM ? getAdditionalInterestTypeValues() : []
        },
        loanNumber: {
            visible: isContractNumberVisible,
            path: 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].contractNumber',
            required: isContractNumberRequired,
            showRequired: isContractNumberRequired
        },
        premiumFinaceCompany: {
            visible: additionalInfoVM?.subtype.value === 'Company' && _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].premiumFinanceCompanyType_TWIA.aspects.visible'),
            required: _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].premiumFinanceCompanyType_TWIA.aspects.required'),
            availableValues: getAvailablePremiumFinaceCompany,
            defaultValue: getAvailablePremiumFinaceCompany[0],
            path: 'policyContactRoles.children[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA.children[0].premiumFinanceCompanyType_TWIA',
        },
        cityKanji: {
            visible: countryCode === 'JP'
        },
        city: {
            label: cityLabel
        },
        state: {
            label: stateLabel,
            visible: countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'JP' || countryCode === 'DE',
            required: countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'JP' || countryCode === 'DE',
            showRequired: countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'JP' || countryCode === 'DE',
            placeholder: placeholderMsg
        },
        zipCode: {
            label: zipCodeLabel,
            onBlur: validateZIPCode,
            validationMessages: zipcodeValidationMessage
        },
        cedex: {
            visible: countryCode === 'FR'
        },
        cedexBureau: {
            visible: countryCode === 'FR' && _.get(additionalInfoVM, 'primaryAddress.cedex_Ext.value') === true,
            validationMessages: cedexBureauValidationMessage
        },
        emailAddress: {
            validationMessages: emailValidationMessage
        },
        statusComponent: {
            visible: (interestTypeValue === 'LOSSP' || interestTypeValue === 'CONSALE') && showAddressValidationStatus,
            primaryAddressVM: additionalInfoVM.primaryAddress.value, status:showAddressValidationStatus,
            isStandardizationDisabled,
            noMatchFound,
            xPortal
        },
        buttonComponent: {
            visible: interestTypeValue === 'LOSSP' || interestTypeValue === 'CONSALE',
            primaryAddressVM: additionalInfoVM.primaryAddress.value, 
            updatePrimaryAddressVM: updateSubmissionVM ,
            authHeader, 
            companyType,
            isStandardizationDisabled,
            standardizationResponse: handleStandardizationResponse,
            xPortal,
            zipCodevalidationMsg: zipcodeValidationMessage
        },
        // DE16717, DE17165
        saveButton: {
            onClick: saveAdditionalInterest,
            disabled: isRenewal ? false : interestTypeValue === 'MORTGAGEE' 
            ? isComponentValid === false 
            : isComponentValid === false || !addInterestButton || isAddressEdited || isButtonDisabled,//DE16671

        } 
    };

    const cancelAdditionalInterest = () => {
        // DE18326
        // isInvalid(true, 'BuildingAdditionalInterestDetails');
        disregardFieldValidation(['BuildingAdditionalInterestDetails'])
        cancelData();
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            OnValidateEmail: validateEmail,
            onCancel: cancelAdditionalInterest,
            onCountryChange: countryChange,
            onContactTypeChange: contactTypeChange,
            onInterestTypeChange: interestTypeChange,
            cedexBureauChange
        },
        resolveComponentMap: {
            standardizeButtonComponent: TWIAStandardizeButton,
            standardizeStatusComponent: TWIAStandardizationStatus
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={additionalInfoVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            showErrors={showErrors || displayError}
        />
    );
}

BuildingAdditionalInterestDetails.propTypes = {
    item: PropTypes.shape({}).isRequired,
    saveData: PropTypes.func.isRequired
};

export default BuildingAdditionalInterestDetails;